export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes1d_sell.2ff21c0f.mp3";